import { useEffect, useState } from 'react';
import { initializeSockets, Sockets } from 'core/sockets';

import getSocketsConfig from '../helpers/getSocketsConfig';

export default ({ shouldSubscribe, channel, callback }) => {
  const [isConnectionInitialized, setIsConnectionInitialized] = useState(Sockets.isConnected);

  useEffect(
    () =>
      initializeSockets(
        () => setIsConnectionInitialized(true),
        getSocketsConfig({ role: 'admin' }),
      ),
    [],
  );

  useEffect(() => {
    const { isConnected, connection } = Sockets;

    if (!isConnected || !shouldSubscribe || !channel || Sockets.channels[channel]) return;

    const subscription = connection.getSubscription(channel) || connection.newSubscription(channel);

    subscription.subscribe();

    const cleanup = () => {
      subscription.unsubscribe();
      subscription.removeAllListeners();
    };

    subscription.on('publication', (message) => {
      callback(message);
      cleanup();
    });

    return cleanup;
  }, [isConnectionInitialized, Sockets.isConnected, shouldSubscribe, channel]);
};
